import React, { useState, useEffect } from "react";
import Activity from "../components/Home/HomeNew/Activity";
import Articles from "../components/Home/HomeNew/Articles";
import DokumenVerification from "../components/Home/HomeNew/DokumenVerification";
import FooterHero from "../components/Home/HomeNew/FooterHero";
import RunningText from "../components/Home/RunningText";
import Hero from "../components/Home/HomeNew/Hero/";
import ListInstance from "../components/Home/HomeNew/ListInstance/";
import Videos from "../components/Home/HomeNew/Videos";
import ModalDetail from "../components/ListOfOrganizer/ListOfOrganizerNew/MainOrganizer/ModalDetail";

import Layout from "../layout/Main";
import { http } from "../misc/http";

export default function HomeNew() {
  const [banner, setBanner] = useState([]);
  const [organizer, setOrganizer] = useState([]);
  const [article, setArticle] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [event, setEvent] = useState([]);
  const [eventWebinar, setEventWebinar] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [selectedID, setSelectedID] = useState(null);

  const saveResponse = (data, setData) => {
    setData(data.data);
  };

  useEffect(() => {
    handleGetAll(`settings/banner`, setBanner);
    handleGetAll(`organizer`, setOrganizer);
    handleGetAll(`blog`, setArticle);
    // handleGetAll(`events?eventType=webinar`, setEventWebinar);
    // handleGetAll(`events?status=publish`, setEvent);
    handleGetAll(`gallery?status=publish`, setGallery);
  }, []);

  useEffect(() => {
    if (selectedID) setOpenModal(true);
  }, [selectedID]);

  const handleGetAll = async (path, stateName) => {
    let params = {
      method: "GET",
      path: path,
      showMessage: false,
    };
    let { data } = await http(params);
    if (data.status === true && data.code === 200) {
      saveResponse(data, stateName);
    }
  };

  return (
    <>
    <RunningText dataText={eventWebinar} />
    <Layout>
      <Hero banner={banner} />
      <ListInstance
        organizer={organizer}
        handleSelectID={(id) => setSelectedID(id)}
      />
      <Activity />
      <DokumenVerification />
      <Articles article={article} event={event}/>
      <Videos gallery={gallery} />
      <FooterHero />
      <ModalDetail
        isOpen={openModal}
        closeModal={() => {
          setOpenModal(false);
          setSelectedID(null);
        }}
        id={selectedID}
      />
    </Layout>
    </>
  );
}
